// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_2aEH-){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_1BlGB .dualColumn_3y0NE{display:flex;align-content:space-between}.nsAddressForm_1BlGB .dualColumn_3y0NE .firstCol_2M0RO{margin-right:20px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_2aEH-",
	"nsAddressForm": "nsAddressForm_1BlGB",
	"dualColumn": "dualColumn_3y0NE",
	"firstCol": "firstCol_2M0RO"
};
module.exports = exports;
